import React, { useEffect, useState } from "react";

export function isMaintenanceWindow() {
  const now = new Date();
  const istOffset = 5.5 * 60 * 60 * 1000;
  const ist = new Date(now.getTime() + istOffset);
  const hours = ist.getUTCHours();
  const minutes = ist.getUTCMinutes();
  const total = hours * 60 + minutes;
  // 1:30am (90) to 6:30am (390) IST
  return total >= 90 && total < 390;
}

export default function MaintenanceScreen() {
  const [timeLeft, setTimeLeft] = useState("");

  useEffect(() => {
    function calcTimeLeft() {
      const now = new Date();
      const istOffset = 5.5 * 60 * 60 * 1000;
      const ist = new Date(now.getTime() + istOffset);
      const hours = ist.getUTCHours();
      const minutes = ist.getUTCMinutes();

      // Minutes until 6:30am IST
      const resumeMinutes = 6 * 60 + 30;
      const currentMinutes = hours * 60 + minutes;
      let diff = resumeMinutes - currentMinutes;
      if (diff < 0) diff += 24 * 60;

      const h = Math.floor(diff / 60);
      const m = diff % 60;
      setTimeLeft(h > 0 ? `${h}h ${m}m` : `${m}m`);
    }

    calcTimeLeft();
    const timer = setInterval(calcTimeLeft, 60000);
    return () => clearInterval(timer);
  }, []);

  return (
    <div className="min-h-screen bg-gray-50 flex items-center justify-center px-4">
      <div className="max-w-md w-full text-center">
        <div className="bg-white rounded-2xl shadow-lg p-10">
          <div className="w-16 h-16 bg-blue-100 rounded-2xl flex items-center justify-center mx-auto mb-6">
            <svg className="w-8 h-8 text-blue-600" fill="none" stroke="currentColor" viewBox="0 0 24 24">
              <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2}
                d="M12 8v4l3 3m6-3a9 9 0 11-18 0 9 9 0 0118 0z" />
            </svg>
          </div>

          <h1 className="text-2xl font-bold text-gray-900 mb-2">EDITINK</h1>
          <p className="text-gray-500 text-sm mb-6">Scheduled Maintenance</p>

          <div className="bg-blue-50 border border-blue-100 rounded-xl px-6 py-4 mb-6">
            <p className="text-gray-700 text-sm">
              We're offline for scheduled maintenance.
            </p>
            <p className="text-gray-900 font-semibold mt-1">
              Back online at <span className="text-blue-600">6:30 AM IST</span>
            </p>
          </div>

          {timeLeft && (
            <p className="text-gray-400 text-sm">
              Resuming in approximately <span className="font-medium text-gray-600">{timeLeft}</span>
            </p>
          )}
        </div>

        <p className="text-gray-400 text-xs mt-6">
          Daily maintenance window: 1:30 AM – 6:30 AM IST
        </p>
      </div>
    </div>
  );
}
